import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { ConsultationProvider } from "@/components/ConsultationModal";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import WebDevelopment from "@/pages/WebDevelopment";
import AppSoftware from "@/pages/AppSoftware";
import ItCloudSecurity from "@/pages/ItCloudSecurity";
import About from "@/pages/About";
import Quote from "@/pages/Quote";
import Contact from "@/pages/Contact";
import Products from "@/pages/Products";
import Admin from "@/pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const { pathname } = window.location;
  const isAdmin = pathname.startsWith("/admin");

  return (
    <BrowserRouter>
      <ScrollToTop />
      <ConsultationProvider>
        <div className="min-h-screen bg-ink text-slate-100 font-sans overflow-x-clip">
          {!isAdmin && <Navbar />}
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/web-development" element={<WebDevelopment />} />
              <Route path="/services/app-software" element={<AppSoftware />} />
              <Route path="/services/it-cloud-security" element={<ItCloudSecurity />} />
              <Route path="/about" element={<About />} />
              <Route path="/quote" element={<Quote />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/products" element={<Products />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          {!isAdmin && <Footer />}
          <Toaster theme="dark" richColors position="top-right" />
        </div>
      </ConsultationProvider>
    </BrowserRouter>
  );
}

export default App;
